import React from 'react';
import NavMenu from '../Nav/NavMenu';
import Footer from '../footer/Footer';
import EmptySlider from '../sliders/EmptySlider';
import FlightImage from "../../assets/static/support.png";
import { Container, Row, Col, Button } from "react-bootstrap";
import dailySavingsImage from "../../assets/static/personal/profile_settings.png"; 

function DailySavingsAccount() {
  return (
    <div>
      <NavMenu></NavMenu>
      <br></br><br></br>
      <EmptySlider 
        title="Daily Savings Account? We’ve got you covered." 
        description="Kontriman offers various ways to assist you with your Daily savings account – via our help center, chat support, and email. Get the support you need, whenever and wherever you need it." 
        imageUrl={FlightImage}
      />

      <div>
        <Container fluid className="my-5 bg-custom">
          <Container className="container-padding">
            <Row className="flex-column flex-md-row">
              {/* Image column */}
              <Col md={6} className="order-1 order-md-1">
                <img
                  src={dailySavingsImage}
                  alt="Daily Savings Account"
                  className="img-fluid"
                />
              </Col>

              {/* Text column */}
              <Col md={6} className="d-flex align-items-center order-2 order-md-2">
                <div>
                  <h1 className="custom_heading">Daily Savings Account</h1>
                  <p>
                    The Daily Savings Account is designed to help you develop a strong saving habit by allowing easy and regular deposits. Watch your savings grow with attractive interest rates and full accessibility when you need it.
                  </p>

                  <h5 className="mt-4">Features</h5>
                  <ul>
                    <li>Make deposits daily or at your convenience</li>
                    <li>Competitive interest rates credited regularly</li>
                    <li>No penalties for withdrawals</li>
                    <li>Secure and convenient online access</li>
                    <li>Ideal for individuals aiming for steady savings growth</li>
                  </ul>

                  <h5 className="mt-4">Who Should Open This Account?</h5>
                  <ul>
                    <li>Individuals seeking to cultivate daily saving habits</li>
                    <li>Young professionals and students</li>
                    <li>Anyone looking for a flexible and accessible savings option</li>
                  </ul>

                  <a href="mailto:info@kontriman.com">
                    <Button className="custom-button mt-3">Open Account</Button>
                  </a>
                </div>
              </Col>
            </Row>
          </Container>
        </Container>
      </div>
      <Footer></Footer>
    </div>
  );
}

export default DailySavingsAccount;
